import { Box, Card, CardContent } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/layouts/Layout';
import { AccountRoutes } from '../../routes/AccountRoutes';
import NewUserEditForm from '../../components/account/users/NewUserEditForm';

const NewUser = ({ customer, accessLevel, accessType, errorHandler }) => {
  const navigate = useNavigate();

  const handleClose = (refresh = false) => {
    navigate('/account/users');
  };

  return (
    <Layout
      routes={AccountRoutes}
      title="Add New User"
      backButtonText="Back to User List"
      handleBackButton={handleClose}
      accessLevel={accessLevel}
      accessType={accessType}
      isHidden={!customer.hasCampaign}
    >
      <NewUserEditForm
        onClose={handleClose}
        errorHandler={errorHandler}
        accessLevel={accessLevel}
        accessType={accessType}
      />
    </Layout>
  );
};

export default NewUser;
